// import React from 'react'

// const TimesheetContent = () => {
//   return (
//     <div>TimesheetContent</div>
//   )
// }

// export default TimesheetContent

import React from "react";
import {
  Divider,
  InfoTimeCard,
  InfoTimeCardAdv,
  PageTitle,
  StatusTags,
} from "../../../../../../components";
import { dateFormator } from "../../../../../../utils";
import { legends } from "../../../../../../components/TimeSheet/legends";

const TableRowData = ({
  title,
  value,
  divider = null,
  titleStyle = "",
  dividerStyle = "",
  valueStyle = "",
}) => {
  return (
    <React.Fragment>
      <div className={`${titleStyle}`}>{title}</div>
      {divider && <div className={`${dividerStyle}`}>{divider}</div>}
      <div className={`${valueStyle}`}>
        {React.isValidElement(value) ? value : value}
      </div>
    </React.Fragment>
  );
};

const TimesheetContent = ({ data = {}, color = "primary", type = "top" }) => {
  //console.log(data);

  return (
    <div className="">
      {type === "top" ? (
        <div className="bg-neutral-100 p-5">
          <div className="flex justify-between items-start gap-x-10 gap-y-5 flex-wrap">
            <div className="grid grid-cols-[auto_auto_auto] items-center gap-x-2 gap-y-1 text-xs">
              <TableRowData
                title="Emp Name"
                value={
                  <div className="flex items-center gap-1">
                    {data.employee.name}{" "}
                    <StatusTags status={data.employee.status} size="xs" />
                  </div>
                }
                divider={":"}
              />
              <TableRowData
                title="Emp Id"
                value={data.employee.id}
                divider={":"}
              />
              <TableRowData
                title="Designation"
                value={data.employee.designation}
                divider={":"}
              />
              <TableRowData
                title="Email"
                value={data.employee.email}
                divider={":"}
              />
            </div>
            <div className="grid grid-cols-[auto_auto_auto] items-center gap-x-2 gap-y-1 text-xs">
              <TableRowData
                title="Client"
                value={data.client.name}
                divider={":"}
              />
              <TableRowData
                title="Address"
                value={data.client.address}
                divider={":"}
              />
              <TableRowData
                title="Email"
                value={data.client.email}
                divider={":"}
              />

              <TableRowData
                title="Phone"
                value={data.client.phone}
                divider={":"}
              />
            </div>
            <div className="flex-1 flex gap-2 self-center">
              <div className="flex-1">
                <InfoTimeCardAdv
                  title="Standard Time"
                  value={data.finalStandardTime}
                  color="primary"
                  size="xs"
                />
              </div>
              <div className="flex-1">
                <InfoTimeCardAdv
                  title="Billable Hours"
                  value={data.finalTotalBillableHours}
                  color="success"
                  size="xs"
                />
              </div>
              <div className="flex-1">
                <InfoTimeCardAdv
                  title="Total Time"
                  value={data.finalTotalHours}
                  color="info"
                  size="xs"
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="px-5 py-2">
          <div className="flex-1 flex flex-wrap gap-x-4 gap-y-2 items-center justify-center">
            {legends.map((item, index) => (
              <div key={index} className="flex items-center gap-1">
                <div className={`w-2.5 h-2.5 rounded-full ${item.color}`}></div>
                <span className="text-xs text-nowrap">{item.name}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TimesheetContent;
